import { Component, DoCheck, inject } from '@angular/core';
import { FieldsetModule } from 'primeng/fieldset';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [FieldsetModule, AvatarModule, ButtonModule],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent implements DoCheck {

  private router = inject(Router)

  navigateTo(route: string){
    this.router.navigate([route]);
  }

  ngDoCheck(): void {
    // console.log('Welcome component checked')
  }
}
